import React, { useMemo, useState } from "react";
import { css } from "@emotion/react";
import { useNavigate } from "react-router-dom";
import { PageTable, Title } from "@src/components";
import { getColumns } from "./KakaoPlusListColumns";
import { initKakaoFriendListFilters, useKakaoFriendList } from "./service";
import { KakaoFriendListFilterType } from "./service/types";

const KakaoPlusList = () => {
    const navigate = useNavigate();
    const columns = getColumns(navigate);

    const [params, setParams] = useState<KakaoFriendListFilterType>(
        initKakaoFriendListFilters,
    );

    const { data } = useKakaoFriendList();

    // API가 전체 목록을 한 번에 반환하므로 클라이언트에서 페이지네이션 처리
    const list = data ?? [];
    const pagedList = useMemo(() => {
        const start = (params.page - 1) * params.limit;
        return list.slice(start, start + params.limit);
    }, [list, params.page, params.limit]);

    return (
        <div css={listStyle}>
            <Title title="카톡 친구 리스트" />
            <div css={tableDivStyle}>
                <PageTable
                    columns={columns}
                    data={pagedList}
                    initialState={{
                        pageIndex: 0,
                        pageSize: params.limit,
                    }}
                    FixedHeight={500}
                    showTotalCount={true}
                    totalCount={list.length}
                    handlePageChange={(index: number) => {
                        const page = index + 1;
                        setParams({ ...params, page });
                    }}
                    forcePageNumber={params.page}
                ></PageTable>
            </div>
        </div>
    );
};

export default KakaoPlusList;

const listStyle = css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
`;

const tableDivStyle = css`
    margin-top: 43px;
    width: 100%;
    height: 80vh;
`;
